import React, { useEffect, useState } from "react";
import { gridColumns_dossDoccAttachments } from "../../Utils/TableColumnDefs";
import CommonGrid from "../CommonGrid";
import { SpinnerBlock } from "../../Utils/CustomComponent";
import axios from "../../axios";
import urls from "../../Utils/urls";

const DossDocAttachmentTable = ({ tHeight = "30vh", className, id }) => {
  const [dossDoccAttachmentsData, setDossDoccAttachmentsData] = useState([]);

  useEffect(() => {
    setDossDoccAttachmentsData(null);
    const fetchData = async () => {
      try {
        const authToken = await axios.get(urls.dashboard.getDossDocToken());
        axios
          .get(
            urls.dosssdoc.getAttachments(id),
            // `https://api-p.loanlinq.com/ords/loanlinq/v1/dossdoc/get_attachment/${id}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken.data.token}`,
              },
            }
          )
          .then((res) => {
            setDossDoccAttachmentsData(res.data.items);
          });
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {dossDoccAttachmentsData ? (
        <CommonGrid
          className={`col-sm-12 ${className}`}
          title={"DOSS DOC Attachments"}
          gridColumns={gridColumns_dossDoccAttachments}
          columnData={dossDoccAttachmentsData}
          // tHeight={tHeight}
        />
      ) : (
        <SpinnerBlock className="col-sm-12" />
      )}
    </>
  );
};

export default DossDocAttachmentTable;
